export function selectOnChangeLink(selectEl) {
  $(selectEl).on('change', (e) => {
    var href = $(`#${$(selectEl).val()}`).attr('href');
    location.href = href;
  });
}
